import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import { Breadcrumb } from "../../../../general/modules/commons/breadcrumb/breadcrumb";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderTitle,
} from "../../../../general/modules/commons/layout/layout";
import { logout } from "../../../../auth/infrastructure/slices/authSlice/authSlice";
import { useTranslation } from "react-i18next";
import { Content } from "../../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../../general/modules/commons/content/contentHeader";
import useCrudForm from "../../../../../hooks/useCrudForm";
import { Link, useParams } from "react-router-dom";
import { ShelvingUnitMutateFormTemplate } from "../commons/templates/shelvingUnitMutateFormTemplate";
import { Button, Form } from "react-bootstrap";
import { EntitySelectField } from "../../../../general/fields/modules/commons/entitySelectField/entitySelectField";
import React, { useState } from "react";
import { RequiredAsterisks } from "../../../../general/modules/commons/Asterisks/requiredAsterisks";
import { shelvingUnitFormSchema } from "../../domain/schemas/shelvingUnitSchema";
import { ShelvingUnitModel } from "../../domain/models/ShelvingUnitModel";
import { pathNameSchema } from "../../../position/domain/schemas/positionLabelSchema";
import { warehouseNameSchema } from "../../../path/domain/schemas/pathSchema";
import useCrudFilters from "../../../../../hooks/useCrudFilters";

export const ShelvingUnitMutatePage = () => {
  const { t } = useTranslation("common");

  const { id } = useParams();

  const dispatch = useAppDispatch();

  const model = useAppSelector((state) => state.crudMutate)
    .model as ShelvingUnitModel & {
    path?: {
      id: string;
      warehouse?: {
        id: string;
      };
    };
  };

  const [pathId, setPathId] = useState<string>(model?.path?.id ?? "");
  const [warehouseId, setWarehouseId] = useState<string>(
    model?.path?.warehouse?.id ?? "",
  );

  const pathFilters = useCrudFilters({
    searchBy: "SearchByRootPath",
    fields: {},
  });

  const title = model.id
    ? t("shelvingUnit.mutate.edit", { name: model.identifier })
    : t("shelvingUnit.mutate.create");

  const crud = useCrudForm({
    schema: shelvingUnitFormSchema,
    prefix: "shelvingUnits",
    createMutation: "upsertShelvingUnit",
    updateMutation: "upsertShelvingUnit",
    deleteMutation: "deleteShelvingUnit",
    id: id ? parseInt(id) : undefined,
    editUrl: "/shelvingUnits/edit/:id",
    formTemplate: ShelvingUnitMutateFormTemplate,
    mutationExclude: ["path"],
    onBeforeSubmit: (values) => {
      return {
        ...values,
        path_id: pathId,
      };
    },
  });

  if (Object.keys(model).length < 1 && id) return <></>;

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb></Breadcrumb>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content>
          <ContentHeader title={t("Tire")} className="mb-3" />
          {crud.form}

          <Form.Group className="mb-3">
            <Form.Label>
              {t("Warehouse")} <RequiredAsterisks />
            </Form.Label>
            <EntitySelectField
              prefix="warehouses"
              entity="Warehouse"
              labelPrefix={"name"}
              id={"warehouses.id"}
              key={"warehouses.id"}
              name={"warehouses.id"}
              value={
                warehouseId === ""
                  ? `${model?.path?.warehouse?.id}`
                  : warehouseId
              }
              onChange={(option) => {
                if (option == null) {
                  pathFilters.removeFilter("warehouse.id");
                  return;
                }
                const { value } = option as { value: string };
                setWarehouseId(value);
                pathFilters.updateFilter("warehouse.id", value);
              }}
              schema={warehouseNameSchema}
              limit={100}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              {t("Path")} <RequiredAsterisks />
            </Form.Label>
            <EntitySelectField
              entity="Path"
              prefix="paths"
              isDisabled={!warehouseId}
              labelPrefix={"identifier"}
              id={"paths.id"}
              key={"paths.id"}
              name={"paths.id"}
              filters={pathFilters.filters}
              value={pathId === "" ? `${model?.path?.id}` : pathId}
              onChange={(option) => {
                if (option === null) return;
                setPathId((option as { value: string }).value);
              }}
              schema={pathNameSchema}
              limit={100000}
            />
          </Form.Group>
        </Content>
        <Content md={4}>
          {crud.manageHeader}
          {model.positionStickers && (
            <Link
              className="mt-2"
              to={model.positionStickers?.pdfUrl}
              target={"_blank"}
            >
              <Button style={{ width: "100%" }}>{t("stickers.open")}</Button>
            </Link>
          )}
          {crud.manage}
        </Content>
      </LayoutContent>
    </Layout>
  );
};
